// Auto-extracted for Pass 3: keep LandingInner slim and easier to maintain

export const EN = {
  nav: {
    concept: "Concept",
    tracks: "Tracks",
    veterans: "Veterans",
    workforce: "Workforce",
    economicOpportunity: "Economic Opportunity",
    federalPartners: "Prime Opportunities",
    securityCompliance: "Security & Compliance",
    communityImpact: "Community Impact",
    plans: "Plans",
    marketplace: "Marketplace",
    donations: "Donations",
    contribution: "Contribution",
    fundraising: "Fundraising",
    payments: "Payments",
    calculator: "Calculator",
    events: "Events",
    outreach: "Outreach",
    volunteer: "Volunteer / Internship",
    finalArrangements: "Final Arrangements",
    legalListings: "Legal Listings",
    partners: "Partners",
    registration: "Registration",
    earlyAccess: "Early Access",
    dashboard: "Dashboard",
    login: "Log In",
    logout: "Log Out",
  },
  hero: {
    tagline:
      "Event Fundraiser · Financial Wellness · Global Aid · Volunteering / Internship · Donations",
    titleLine2: "Wealth · Opportunity · Wellness · Honor",
    lead:
      "A 50/50 fundraising and economic wellness program that supports people in need while helping participants build savings, protection, and future wealth.",
    joinCta: "Join the Opportunity",
    learnCta: "Learn how WOW50/50 works",
  },
  concept: {
    heading: "WOW50/50 — Concept Overview",
    body:
      "WOW50/50 is a structured 50/50 fundraiser and financial wellness program. 50% supports people in need and vetted humanitarian causes. 50% supports savings/wellness tracks, platform operations, and future growth.",
  },
  membership: {
    heading: "Membership & Contribution",
    intro:
      "Membership can start with just $5. At $50 you become a regular member. If your initial membership is below $50, membership confirmation is issued once your total reaches $50.",
    tiersHeading: "Membership types & indicative contribution levels",
    tiers: [
      { name: "Youth", subtitle: "0–17 years", amount: "$5", tag: "Entry / Youth" },
      {
        name: "Senior / ADA Persons / VETs",
        subtitle: "62+ · Low-income · Non-officer's",
        amount: "$10",
        tag: "Support tier",
      },
      {
        name: "High School / Voc-Tech / College / University Students",
        subtitle: "",
        amount: "$20*",
        tag: "Student tier",
      },
      {
        name: "Regular Adults",
        subtitle: "Membership confirmation threshold",
        amount: "$50",
        tag: "Regular member (confirmed at $50)",
      },
      { name: "Business", subtitle: "", amount: "$75*", tag: "Small business" },
      {
        name: "Professional",
        subtitle: "(individual)",
        amount: "$275*",
        tag: "Professional services",
      },
      {
        name: "Corporate",
        subtitle: "Admin $75 / Staff $50",
        amount: "$500",
        tag: "Corporate collaboration",
      },
      {
        name: "Venues (Small)",
        subtitle: "",
        amount: "$250",
        tag: "Small venue partnership",
      },
      {
        name: "Venues (Large)",
        subtitle: "",
        amount: "$500",
        tag: "Large venue partnership",
      },
      {
        name: "Clinics / Medical / Attorney / Tax Prep / Dealerships",
        subtitle: "",
        amount: "$1,500",
        tag: "Major facilities",
      },
      {
        name: "Media",
        subtitle: "Free with 1-year co-op partnership*",
        amount: "$100",
        tag: "Media listing (monthly minimum)",
      },
      {
        name: "PSA / Impact Co-op Partnership",
        subtitle:
          "Emergency alerts, humanitarian services, annual outreach, free certification classes, ecological events, animal advocacy & rescue orgs",
        amount: "Partnership",
        tag: "Impact co-op partnership",
      },
    ],
    disclosureTitle: "Membership Confirmation Disclosure",
    disclosureBody:
      "Membership can start at $5. Full membership confirmation is issued once your total contributions reach $50 (if your first payment is below $50).",
    packagesHeading: "Member Packages & Benefits",
    packages: [
      {
        title: "Fan Club",
        price: "$100 monthly (in addition to membership)",
        bullets: [
          "Membership certificate",
          "WOW50/50 T-shirt (marketplace selection)",
          "Visa card (coming soon)",
        ],
      },
      {
        title: "VIP",
        price: "$275 monthly",
        bullets: [
          "Retail partner discounts",
          "Guayabera selection",
          "Special marketplace offers",
          "Platinum Visa (coming soon)",
        ],
        note:
          "VIP and up: choose guayabera type/size/color. Ladies may choose a shirt or dress (dress +$30).",
      },
      {
        title: "Ambassador",
        price: "$500 every 3 months",
        bullets: [
          "Everything in VIP",
          "Logo pin/pen/bag",
          "Commission: 20% per confirmed membership",
          "Marketplace placement (preview)",
        ],
        highlight: "Pay off your membership by helping increase membership.",
      },
      {
        title: "Global Ambassador",
        price: "$1,500 every 3 months",
        bullets: [
          "Everything in Ambassador",
          "Commission: 25% per confirmed membership",
          "Free business card placement (preview)",
        ],
        note:
          "Bonus: 2nd half-year free membership with recruitment of at least 10 other $1,500 monthly members in the first year. If 20+ in one full year, membership is waived for the next year.",
        finePrint:
          "FREE lifetime membership once registering a minimum of 100 members; in good standing for 5 years, then automatic fee waiver lifetime-membership will be provided.",
      },
      {
        title: "Universal Empire (WOW50/50 Mini Franchise)",
        price: "$1,500 monthly",
        bullets: [
          "Mini franchise (coming soon)",
          "First quarter: 30% per confirmed member",
          "Bonus after 20 sign-ups/month",
        ],
        note:
          "Bonus: 2nd half-year free membership with recruitment of at least 5 other $1,500 monthly members in the first year. If 10+ in one full year, membership is waived for the next year.",
        finePrint:
          "FREE lifetime membership once registering a minimum of 50 members; in good standing for 5 years, then automatic fee waiver lifetime-membership will be provided.",
      },
    ],
    taxFinePrint:
      "Global Ambassador B: year-end tax form concept preview is 1099 (info).",
    taxHeading: "Year-End Tax Forms (Info)",
    taxBody:
      "Receipts and information forms may be provided where applicable (depending on the final compliant structure and donor eligibility).",
  },
  marketplace: {
    heading: "Marketplace & Member Offers",
    body:
      "The WOW50/50 Marketplace allows approved participants, partners, and small businesses to list products, services, and cause-driven offers. Donation listings can be marked with a red frame.",
    externalCta: "Open Marketplace",
    vendorCta: "Apply as a Vendor",
    memberDiscounts:
      "Members may receive 10%–20% discounts depending on the merchant, locations, and seasons.",
    taxReceipt:
      "Donations may qualify for a tax-exempt receipt (where applicable).",
  },
  donationSection: {
    heading: "Donations",
    sub:
      "Examples of items donated to WOW50/50. Tap a card to publish details (description + price + photos) and optionally list it directly to the marketplace — or continue intake.",
    cardCta: "Tap to publish details (or continue intake)",
    items: {
      cars: "Cars",
      clothes: "Clothes",
      motorcycles: "Two-Wheelers",
      twoWheelers: "Two-Wheelers",
      boats: "Boats",
      houses: "Houses",
      lands: "Lands",
      rvs: "RVs",
      plants: "Plants",
      jewelry: "Jewelry",
      constructionEquipment: "Construction Equipment",
      kitchenAppliances: "Kitchen Appliances",
      commercialProperties: "Commercial Properties",
      officeEquipment: "Office Equipment",
      airlineMileageCredit: "Airline Mileage Credit",
      foodAndBeverages: "Food & Beverages",
    },
    dedicationLabel: "Dedication / Memorial Note (optional)",
    itemType: "Donation Type",
    directLabel: "This item is donated directly to WOW50/50",
    directHelp: "Direct donations can be marked with a red frame.",
    tabItems: "In-Kind Donations",
    tabMedia: "Electronic News / Media",
    tabServices: "In-Kind Services",
    tabMemorial: "Memorial / Legacy",
  },
  donationIntake: {
    heading: "Donation Intake",
    sub:
      "Confirm donation type and dedication. We will email your receipt request and follow-up instructions.",
    submit: "Submit Donation Intake",
  },
  contributionSection: {
    heading: "Contribution",
    sub:
      "Fund contributions (financial). Choose frequency, amount, and optional dedication each time you contribute.",
    frequency: "Frequency",
    amount: "Amount",
    dedication: "Dedication / Memorial Note (optional)",
    submit: "Submit Contribution",
  },
  fundraising: { heading: "Fundraising & Global Aid Snapshot" },
  payments: {
    heading: "Payment & Contribution Processing",
    body:
      "WOW50/50 will integrate with compliant payment processors so participants can contribute using cards or bank payments.",
    button: "Payments coming soon",
  },
  calculator: {
    heading: "Contribution & Wealth Engine Calculator",
    body:
      "Visual example of how a monthly contribution may be structured under the WOW Wealth Engine model.",
  },
  events: { heading: "Events · Campaigns · Activations" },
  outreach: {
    heading: "Community & Ecological Outreach Events",
    body:
      "We host community and ecological outreach events. We provide community service hours and contribution value letters.",
  },
  volunteer: {
    heading: "Volunteer / Internship",
    body:
      "Volunteer with outreach events, fundraising campaigns, marketplace operations, and community support initiatives.",
  },
  finalArrangements: {
    heading: "Final Arrangements & Memorials",
    sub:
      "Discount navigation for cremation, burial, and global shipping to a final destination. Includes a memorial page option.",
    memorialTitle: "Memorial Page (1 month listing)",
    memorialBody:
      "Add a memorial statement and photo (gallery). Example fee: $50/month for posting.",
  },
  legalListings: {
    heading: "Legal Listings & Public Notices",
    sub:
      "Click a category to publish a listing (headline, description, contact info, and optional pricing/files).",
    items: [
      "Public",
      "Commercial",
      "Court Order",
      "Fictitious",
      "Announcement",
      "Legal Listing",
      "Legal Support",
      "Tourist / Travel",
      "Rural / Agriculture",
      "Surplus Properties",
      "Flea Markets / Auctions",
      "Media / Production / Security",
      "Recycling Venues",
      "Minority Products",
      "Language Classes",
      "Pet Services",
    ],
    publishHint:
      "Publish: headline · description · contact · optional price/files",
    directoryTitle: "US data directory",
    directorySub:
      "Connect federal + state + county sources. Many jurisdictions have no unified API; this lists official portals and plug-in connectors.",
    selectState: "State",
    selectCounty: "County",
    allCounties: "All counties",
    loadingCounties: "Loading counties…",
    sourcesTitle: "Connectors you can integrate",
    tipLocal:
      "Tip: for local dev, run `vercel dev` so /api endpoints work (county list + server-side connectors).",
    coverageLabel: "Coverage",
    accessLabel: "Access",
  },
  partners: {
    heading: "Core Partners & Sponsors",
    futureSmall: "Future partners & sponsors (branding and co-promotion).",
  },
  registration: {
    heading: "Registration (Preview)",
    body:
      "Registration workflows will be enabled as legal, compliance, and payment components are finalized.",
  },
  earlyAccess: {
    title: "Join WOW50/50 — Early Access List",
    description:
      "Enter your information to receive updates as legal, banking, and compliance structures finalize.",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email Address",
    address: "Address",
    ageRange: "Age Range",
    orgLine:
      "We are a humanitarian and research organization — please provide city/parish, state/providence, country, region, and ZIP code.",
    cityParish: "City / Parish",
    stateProvince: "State / Providence",
    country: "Country",
    region: "Region",
    zip: "ZIP / Postal Code",
    useLabel: "How would you like to use WOW50/50?",
    usePlaceholder:
      "For example: fundraising for a program, building personal savings, volunteering, marketplace access, etc.",
    permission:
      "I give WOW50/50 permission to share my information for other benefits, discounts, opportunities, and privileged timely information (when available).",
    attachmentsTitle: "Attachments (optional)",
    attachmentsDesc: "Upload documents or images. We save filenames + email filenames.",
    consentText: "I confirm the information is accurate and I consent to be contacted by WOW50/50.",
    button: "Join Early Access",
    success: "Thank you — you're on the early access list.",
    error: "Something went wrong. Please try again.",
  },

  programTracks: {
    veterans: {
      heading: "Veteran & Military Support Programs",
      startIntake: "Start intake",
      blurb:
        "WOW50/50 includes dedicated pathways that support veterans, active duty members, civilian workers, and military families through employment, entrepreneurship, and reintegration services.",
      helpTitle: "Information & Referral Services",
      helpBullets: [
        "Mental health & physical rehabilitation wellness opportunities, including holistic options.",
        "Transition & reintegration services (housing stability, community connection, re-entry support).",
        "SDVOSB / VOSB readiness language (certification-ready positioning & pathways).",
        "Veteran employment pathways (training → placement → retention support).",
        "Support for veteran/active-duty loved ones, family & pets.",
        "Funding opportunity navigation (transportation, properties, housing, business & innovative concepts).",
        "Veteran/AD-owned business support (launch, growth, marketing, marketplace access).",
        "Partnerships & vending with VA / employers (active or planned MOUs / pipelines).",
      ],
      unlocksTitle: "Unlocks",
      unlocksBullets: [
        "DOL VETS funding opportunities, grants, endorsements, angel investments, and veteran business alignment.",
        "VA OSDBU credibility for outreach & events.",
        "Prime interest (SAIC / GDIT and other large employers).",
        "Vending & procurement registration, mentoring, internships, and contracting pathways.",
      ],
      notes:
        "Note: Language is presented as program design and readiness support (not legal advice / not a certification).",
      trackLabel: "Veteran & Military Support",
      options: [
        { id: "employment", label: "Training + job placement" },
        { id: "business-support", label: "Start / grow a veteran-owned business" },
        { id: "transition", label: "Transition / reintegration support" },
        { id: "sdvosb-vosb", label: "SDVOSB / VOSB readiness" },
        { id: "funding", label: "Funding opportunities" },
        { id: "family", label: "Family / loved ones / pets support" },
        { id: "partnerships", label: "VA / employer partnerships" },
      ],
      partnersTitle: "For partners & community organizations",
      partnersBody1:
        "This track is designed for measurable outcomes: training enrollments, placement, and ongoing support.",
      partnersBody2:
        "Our intake and routing workflow helps veterans get to the right resource quickly.",
    },
    workforce: {
      heading: "Workforce Development & Career Pathways",
      startIntake: "Start intake",
      blurb:
        "Need a better job, a new skill, or a faster path into work? WOW50/50 helps you build a skills-first plan and connects you to training, employer matching, and real next steps — without requiring a traditional degree.",
      helpTitle: "How we can help",
      helpBullets: [
        "Skills training (digital, admin, IT, marketplace operations).",
        "Skills-first pathways (STARs / competency-based progress) to qualify faster.",
        "Job placement support + employer matching (referrals, warm introductions).",
        "Upskilling support for re-entry and career changes.",
        "Outcome tracking (enrollments, completions, placements) to keep programs accountable.",
      ],
      trackLabel: "Workforce Development",
      options: [
        { id: "skills-training", label: "Skills training / upskilling" },
        { id: "employment", label: "Job placement / employer matching" },
        { id: "re-entry", label: "Re-entry / second chance support" },
        { id: "certs", label: "Industry cert guidance" },
        { id: "partnerships", label: "Employer / training partner" },
      ],
      partnersTitle: "For employers & workforce partners",
      partnersBody1:
        "We support skills-based hiring pipelines: intake, screening, training referrals, placement support, and outcome reporting.",
      partnersBody2:
        "Partner with WOW50/50 to expand your talent pipeline and deliver measurable results.",
    },
    economicOpportunity: {
      heading: "Economic Opportunity & Financial Empowerment",
      startIntake: "Start intake",
      blurb:
        "Build financial stability, learn how to access capital responsibly, and grow long-term wealth. WOW50/50 supports budgeting, credit tools, savings plans, and small-business readiness.",
      helpTitle: "How we can help",
      helpBullets: [
        "Financial wellness coaching (budgeting, savings plans, debt strategy).",
        "Credit-building guidance and tools (education + next steps).",
        "Access-to-capital education (loan readiness, documents, lender navigation).",
        "Small business readiness (pricing, bookkeeping basics, digital presence).",
        "Community wealth-building pathways and referrals.",
      ],
      trackLabel: "Economic Opportunity",
      options: [
        { id: "budgeting", label: "Budgeting / savings plan" },
        { id: "credit", label: "Credit building guidance" },
        { id: "access-to-capital", label: "Access to capital education" },
        { id: "business-support", label: "Small business readiness" },
        { id: "partnerships", label: "Partner / sponsor support" },
      ],
      partnersTitle: "For financial partners & community programs",
      partnersBody1:
        "We focus on measurable progress: education, action steps, and follow-through — so people can move from crisis to stability and growth.",
      partnersBody2:
        "Partner with WOW50/50 to support community wealth-building and small-business readiness.",
    },
    federalPartners: {
      heading: "Prime Opportunities & Contracting Readiness",
      startIntake: "Start intake",
      blurb:
        "Learn the steps to become vendor-ready and compete for federal, state, and local opportunities. WOW50/50 supports capability statements, compliance awareness, and prime/sub relationship readiness (not certification).",
      helpTitle: "How we can help",
      helpBullets: [
        "Vendor readiness basics (capability statement, NAICS, differentiators).",
        "Prime–sub matchmaking support and partnership outreach.",
        "SAM.gov / compliance awareness guidance (education, not certification).",
        "Subcontracting readiness (pricing, documentation, performance narrative).",
        "Referral routing to local procurement and OSDBU resources.",
      ],
      trackLabel: "Prime Opportunities",
      options: [
        { id: "vendor-ready", label: "Vendor readiness basics" },
        { id: "capability", label: "Capability statement support" },
        { id: "federal-market-entry", label: "Subcontracting / market entry" },
        { id: "sam", label: "SAM.gov / compliance awareness" },
        { id: "partnerships", label: "Prime partner outreach" },
      ],
      partnersTitle: "For primes, agencies & ecosystem partners",
      partnersBody1:
        "We help small businesses get organized and ready for real opportunities with clear next steps and compliant routing.",
      partnersBody2:
        "Partner with WOW50/50 to expand subcontractor pipelines and improve readiness outcomes.",
    },
    securityCompliance: {
      heading: "Cybersecurity & Compliance Readiness",
      startIntake: "Start intake",
      blurb:
        "Protect your organization, customers, and data. WOW50/50 supports practical cybersecurity education, risk basics, and compliance readiness pathways (including CMMC awareness).",
      helpTitle: "How we can help",
      helpBullets: [
        "Cyber hygiene basics (passwords, MFA, phishing prevention).",
        "Data protection practices for small teams (policies + tools).",
        "CMMC / compliance awareness education and readiness steps (not certification).",
        "Vendor responsibility and security documentation support.",
        "Referrals to trusted partners for assessments and implementation.",
      ],
      trackLabel: "Security & Compliance",
      options: [
        { id: "cmmc-awareness", label: "CMMC / compliance awareness" },
        { id: "data-protection", label: "Data protection practices" },
        { id: "policies", label: "Policies & documentation" },
        { id: "training", label: "Security training / awareness" },
        { id: "partnerships", label: "Partner / assessment referral" },
      ],
      partnersTitle: "For cybersecurity partners & compliance programs",
      partnersBody1:
        "We help participants understand requirements, take practical steps, and connect to verified providers for deeper work.",
      partnersBody2:
        "Partner with WOW50/50 to expand readiness education and responsible vendor practices.",
    },
    communityImpact: {
      heading: "Community Impact & Public Benefit",
      startIntake: "Start intake",
      blurb:
        "Support communities through volunteering, mutual aid, and measurable public benefit. WOW50/50 helps connect people to local programs, events, and service pathways.",
      helpTitle: "How we can help",
      helpBullets: [
        "Volunteer and internship placement opportunities.",
        "Community programs and partner referrals (food access, housing stability, re-entry).",
        "Event-based fundraising and outreach coordination.",
        "Public benefit tracking and reporting support.",
        "Connections to trusted local nonprofits and services.",
      ],
      trackLabel: "Community Impact",
      options: [
        { id: "volunteer-programs", label: "Volunteer / internship placement" },
        { id: "events", label: "Events / outreach" },
        { id: "food-access", label: "Food access support" },
        { id: "housing", label: "Housing stability referral" },
        { id: "partnerships", label: "Nonprofit / partner collaboration" },
      ],
      partnersTitle: "For nonprofits & public benefit partners",
      partnersBody1:
        "We focus on clear routing, measurable engagement, and connecting volunteers to real community needs.",
      partnersBody2:
        "Partner with WOW50/50 to increase participation, improve outcomes, and strengthen local support systems.",
    },
  },

  intakeInline: {
    title: "Quick intake",
    sub:
      "Tell us what you’re looking for — we’ll route you to the right program and next steps.",
    fullIntake: "Full intake",
    interestedIn: "I’m interested in",
    zipOptional: "ZIP (optional)",
    fullName: "Full name",
    yourName: "Your name",
    email: "Email",
    phoneOptional: "Phone (optional)",
    notesOptional: "Notes (optional)",
    notesPlaceholder: "Tell us your goal and timeline (optional).",
    submit: "Submit",
    submitting: "Submitting…",
    success:
      "Thanks — we received your request. Next: use the button below to continue.",
    errorName: "Please enter your name.",
    errorEmail: "Please enter your email.",
    footer: "We’ll respond with next steps and the right resources.",
    continue: "Continue →",
  },

  intakePage: {
    heading: "Intake Form",
    sub:
      "Tell us what you need and we’ll route you to the right programs, resources, and next steps.",
    back: "Back",
    programArea: "Program area",
    select: "Select…",
    iAm: "I am a…",
    roles: {
      individual: "Community member / individual",
      business: "Business owner",
      nonprofit: "Nonprofit / community org",
      partner: "Employer / partner / agency",
    },
    fullName: "Full name",
    email: "Email",
    phoneOptional: "Phone (optional)",
    zipOptional: "ZIP (optional)",
    needsTitle: "What do you need help with?",
    tip: "Tip: you can select multiple — we’ll route you to the right place.",
    notesOptional: "Notes (optional)",
    notesPlaceholder: "Briefly tell us your goal, timeline, and any constraints.",
    submit: "Submit intake",
    submitting: "Submitting…",
    errProgram: "Please select a program area.",
    errName: "Please enter your name.",
    errEmail: "Please enter your email.",
    success:
      "Submitted. Next: use the buttons below to continue to the right place.",
    nextSteps: "Next steps",
    backToStart: "Back to where you started",
    goTo: "Go to {program}",
    contactUs: "Contact us",
    volunteer: "Volunteer",
    review:
      "We’ll review your intake and follow up with the right program path and official resources.",
    needsOptions: {
      employment: "Employment / job placement",
      skillsTraining: "Skills training / upskilling",
      businessSupport: "Business support / marketplace access",
      accessToCapital: "Access to capital education",
      federalMarketEntry: "Federal contracting entry / subcontracting",
      cmmcAwareness: "Cybersecurity / compliance readiness",
      volunteerPrograms: "Volunteer / community engagement",
      partnerships: "Partnership / employer pipeline",
    },
  },

  ticket: {
    heading: "Support Ticket",
    sub: "Need help? Send a ticket and we’ll follow up by email.",
    name: "Name (optional)",
    email: "Email",
    subject: "Subject (optional)",
    message: "Message",
    submit: "Submit Ticket",
    success: "Ticket sent. Thank you.",
    error: "Ticket failed. Please try again.",
  },
  footer: {
    tollFree: "Toll free global ph#:",
    hashtag: "#wow5050",
    madeBy: "WOW50/50©️®️™️ is a 2025-6, LRHC&EDC & Global Economic CDC/ A GlobalSOSNOW, Website Program. In partnership exclusively with Toussaint Digital Development within the USA.",
    copyright: "© {year} WOW50/50. All rights reserved.",
  },
};

export const ES = {
  nav: {
    concept: "Concepto",
    tracks: "Rutas",
    veterans: "Veteranos",
    workforce: "Fuerza laboral",
    economicOpportunity: "Oportunidad económica",
    federalPartners: "Socios federales",
    securityCompliance: "Seguridad y cumplimiento",
    communityImpact: "Impacto comunitario",
    plans: "Planes",
    marketplace: "Mercado",
    donations: "Donaciones",
    contribution: "Contribución",
    fundraising: "Recaudación",
    payments: "Pagos",
    calculator: "Calculadora",
    events: "Eventos",
    outreach: "Alcance",
    volunteer: "Voluntariado / Prácticas",
    finalArrangements: "Arreglos Finales",
    legalListings: "Avisos Legales",
    partners: "Socios",
    registration: "Registro",
    earlyAccess: "Acceso Anticipado",
    dashboard: "Panel",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
  },
  hero: {
    tagline:
      "Recaudación de eventos · Bienestar financiero · Ayuda global · Voluntariado / Prácticas · Donaciones",
    titleLine2: "Riqueza · Oportunidad · Bienestar · Honor",
    lead:
      "Un programa de recaudación 50/50 y bienestar económico que apoya a personas necesitadas mientras ayuda a los participantes a crear ahorros, protección y riqueza futura.",
    joinCta: "Únete a la Oportunidad",
    learnCta: "Cómo funciona WOW50/50",
  },
  concept: {
    heading: "WOW50/50 — Resumen del Concepto",
    body:
      "WOW50/50 es un programa estructurado de recaudación 50/50 y bienestar financiero. El 50% apoya a personas necesitadas y causas humanitarias verificadas. El otro 50% apoya rutas de ahorro/bienestar, operaciones de la plataforma y crecimiento futuro.",
  },
  membership: {
    heading: "Membresía y Marco de Contribución",
    intro:
      "La membresía puede comenzar desde $5. Con $50 te conviertes en miembro regular. Si tu membresía inicial es menor de $50, la confirmación se emite cuando tu total alcance $50.",
    tiersHeading: "Tipos de membresía y niveles indicativos de contribución",
    tiers: [
      { name: "Juventud", subtitle: "0–17 años", amount: "$5", tag: "Entrada / Juventud" },
      {
        name: "Personas mayores / ADA / Veteranos",
        subtitle: "62+ · Bajos ingresos · No-oficial",
        amount: "$10",
        tag: "Nivel de apoyo",
      },
      {
        name: "Estudiantes (Secundaria / Técnico / Universidad)",
        subtitle: "",
        amount: "$20*",
        tag: "Nivel estudiante",
      },
      {
        name: "Adultos regulares",
        subtitle: "Umbral de confirmación",
        amount: "$50",
        tag: "Miembro regular (confirmado a $50)",
      },
      { name: "Negocio", subtitle: "", amount: "$75*", tag: "Pequeña empresa" },
      {
        name: "Profesional",
        subtitle: "(individual)",
        amount: "$275*",
        tag: "Servicios profesionales",
      },
      {
        name: "Corporativo",
        subtitle: "Admin $75 / Personal $50",
        amount: "$500",
        tag: "Colaboración corporativa",
      },
      {
        name: "Locales (pequeños)",
        subtitle: "",
        amount: "$250",
        tag: "Asociación local pequeña",
      },
      {
        name: "Locales (grandes)",
        subtitle: "",
        amount: "$500",
        tag: "Asociación local grande",
      },
      {
        name: "Clínicas / Médico / Abogado / Impuestos / Concesionarios",
        subtitle: "",
        amount: "$1,500",
        tag: "Instalaciones principales",
      },
      {
        name: "Medios",
        subtitle: "Gratis con alianza co-op de 1 año*",
        amount: "$100",
        tag: "Listado de medios (mínimo mensual)",
      },
      {
        name: "PSA / Alianza Co-op de Impacto",
        subtitle:
          "Alertas de emergencia, servicios humanitarios, alcance anual, clases de certificación gratuitas, eventos ecológicos, defensa animal y rescate",
        amount: "Alianza",
        tag: "Alianza co-op de impacto",
      },
    ],
    disclosureTitle: "Divulgación de Confirmación de Membresía",
    disclosureBody:
      "La membresía puede comenzar en $5. La confirmación completa se emite cuando el total de contribuciones alcanza $50 (si el primer pago es menor de $50).",
    packagesHeading: "Paquetes y Beneficios",
    packages: [
      {
        title: "Fan Club",
        price: "$100 mensual (además de la membresía)",
        bullets: [
          "Certificado de membresía",
          "Camiseta WOW50/50 (selección del marketplace)",
          "Tarjeta Visa (próximamente)",
        ],
      },
      {
        title: "VIP",
        price: "$275 mensual",
        bullets: [
          "Descuentos con socios minoristas",
          "Selección de guayabera",
          "Ofertas especiales del marketplace",
          "Visa Platinum (próximamente)",
        ],
        note:
          "VIP y superior: elige tipo/talla/color de guayabera. Damas: camisa o vestido (vestido +$30).",
      },
      {
        title: "Embajador",
        price: "$500 cada 3 meses",
        bullets: [
          "Todo en VIP",
          "Pin/bolígrafo/bolsa con logo",
          "Comisión: 20% por membresía confirmada",
          "Posicionamiento en marketplace (preview)",
        ],
        highlight: "Paga tu membresía ayudando a aumentar membresías.",
      },
      {
        title: "Embajador Global",
        price: "$1,500 cada 3 meses",
        bullets: [
          "Todo en Embajador",
          "Comisión: 25% por membresía confirmada",
          "Colocación gratis de tarjeta de negocio (preview)",
        ],
        note:
          "Bono: 2ª mitad del año gratis con reclutamiento de mínimo 10 miembros mensuales de $1,500 en el primer año. Si 20+ en un año completo, se exime el siguiente año.",
        finePrint:
          "Membresía vitalicia GRATIS al registrar mínimo 100 miembros; en buen estado por 5 años → exención automática de por vida.",
      },
      {
        title: "Universal Empire (Mini Franquicia WOW50/50)",
        price: "$1,500 mensual",
        bullets: [
          "Mini franquicia (próximamente)",
          "Primer trimestre: 30% por miembro confirmado",
          "Bono después de 20 registros/mes",
        ],
        note:
          "Bono: 2ª mitad del año gratis con reclutamiento de mínimo 5 miembros mensuales de $1,500 en el primer año. Si 10+ en un año completo, se exime el siguiente año.",
        finePrint:
          "Membresía vitalicia GRATIS al registrar mínimo 50 miembros; en buen estado por 5 años → exención automática de por vida.",
      },
    ],
    taxFinePrint:
      "Embajador Global B: vista previa del concepto de formulario fiscal de fin de año es 1099 (info).",
    taxHeading: "Formularios fiscales de fin de año (Info)",
    taxBody:
      "Recibos y formularios informativos pueden proporcionarse cuando corresponda (según la estructura final y elegibilidad del donante).",
  },
  marketplace: {
    heading: "Mercado y Ofertas de Miembros",
    body:
      "El Mercado WOW50/50 permite a participantes aprobados, socios y pequeños negocios listar productos, servicios y ofertas con causa. Las donaciones pueden marcarse con un marco rojo.",
    externalCta: "Abrir Mercado",
    vendorCta: "Solicitar como Vendedor",
    memberDiscounts:
      "Los miembros pueden recibir descuentos del 10%–20% según el comercio, ubicación y temporada.",
    taxReceipt:
      "Las donaciones pueden calificar para recibos exentos de impuestos (cuando corresponda).",
  },
  donationSection: {
    heading: "Donaciones",
    sub:
      "Ejemplos de artículos donados a WOW50/50. Toca una tarjeta para publicar detalles (descripción + precio + fotos) y opcionalmente listar en el mercado — o continuar con la admisión.",
    cardCta: "Toca para publicar detalles (o continuar la admisión)",
    items: {
      cars: "Cars",
      clothes: "Clothes",
      motorcycles: "Two-Wheelers",
      twoWheelers: "Two-Wheelers",
      boats: "Boats",
      houses: "Houses",
      lands: "Lands",
      rvs: "RVs",
      plants: "Plants",
      jewelry: "Jewelry",
      constructionEquipment: "Construction Equipment",
      kitchenAppliances: "Kitchen Appliances",
      commercialProperties: "Commercial Properties",
      officeEquipment: "Office Equipment",
      airlineMileageCredit: "Airline Mileage Credit",
      foodAndBeverages: "Food & Beverages",
    },
    dedicationLabel: "Dedicatoria / Nota conmemorativa (opcional)",
    itemType: "Tipo de donación",
    directLabel: "Este artículo se dona directamente a WOW50/50",
    directHelp: "Las donaciones directas pueden marcarse con un marco rojo.",
    tabItems: "Donaciones en especie",
    tabMedia: "Noticias / Medios",
    tabServices: "Servicios en especie",
    tabMemorial: "Memorial / Legado",
  },
  donationIntake: {
    heading: "Admisión de Donación",
    sub:
      "Confirma el tipo de donación y dedicatoria. Te enviaremos por correo electrónico tu recibo y las instrucciones.",
    submit: "Enviar admisión de donación",
  },
  contributionSection: {
    heading: "Contribución",
    sub:
      "Contribuciones al fondo (financieras). Elige frecuencia, monto y dedicatoria opcional en cada contribución.",
    frequency: "Frecuencia",
    amount: "Monto",
    dedication: "Dedicatoria / Nota conmemorativa (opcional)",
    submit: "Enviar contribución",
  },
  fundraising: { heading: "Recaudación y Ayuda Global" },
  payments: {
    heading: "Procesamiento de Pagos y Contribuciones",
    body:
      "WOW50/50 integrará procesadores de pago conformes para aceptar tarjetas o pagos bancarios.",
    button: "Pagos próximamente",
  },
  calculator: {
    heading: "Calculadora de Contribución y Motor de Riqueza",
    body:
      "Ejemplo visual de cómo puede estructurarse una contribución mensual bajo el modelo WOW Wealth Engine.",
  },
  events: { heading: "Eventos · Campañas · Activaciones", body: "Publica eventos y campañas. Se guardan en este dispositivo y pueden notificar al equipo WOW." },
  outreach: {
    heading: "Eventos de Alcance Comunitario y Ecológico",
    body:
      "Organizamos eventos comunitarios y ecológicos. Proveemos horas de servicio comunitario y cartas de valor de contribución.",
  },
  volunteer: {
    heading: "Voluntariado / Prácticas",
    body:
      "Apoya eventos de alcance, campañas de recaudación, operaciones del mercado y apoyo comunitario.",
  },
  finalArrangements: {
    heading: "Arreglos Finales y Memoriales",
    sub:
      "Navegación con descuento para cremación, entierro y envíos globales. Incluye opción de página memorial.",
    memorialTitle: "Página memorial (1 mes)",
    memorialBody:
      "Agrega un mensaje memorial y foto (galería). Ejemplo: $50/mes por publicación.",
  },
  legalListings: {
    heading: "Avisos Legales y Anuncios Públicos",
    sub:
      "Haz clic en una categoría para publicar (título, descripción, contacto y precio/archivos opcionales).",
    items: [
      "Público",
      "Comercial",
      "Orden judicial",
      "Nombre ficticio",
      "Anuncio",
      "Aviso legal",
      "Apoyo legal",
      "Turismo / Viajes",
      "Rural / Agricultura",
      "Propiedades excedentes",
      "Pulgas / Subastas",
      "Medios / Producción / Seguridad",
      "Reciclaje",
      "Productos de minorías",
      "Clases de idiomas",
      "Servicios para mascotas",
    ],
    publishHint:
      "Publicar: título · descripción · contacto · precio/archivos opcionales",
    directoryTitle: "Directorio de datos de EE. UU.",
    directorySub:
      "Conecta fuentes federales, estatales y del condado. Muchas jurisdicciones no ofrecen una API unificada — enlazamos portales oficiales y añadimos conectores con el tiempo.",
    selectState: "Estado",
    selectCounty: "Condado",
    allCounties: "Todos los condados",
    loadingCounties: "Cargando condados…",
    sourcesTitle: "Conectores que puedes integrar",
    coverage: {
      federal: "Federal",
      state: "Estatal",
      county: "Condado",
      multi: "Multiestado",
      paid: "De pago / requiere acceso",
    },
    coverageLabel: "Cobertura",
    accessLabel: "Acceso",
    noteLocal:
      "Consejo: En desarrollo local, ejecuta `vercel dev` para que /api funcione (lista de condados y conectores).",
  },
  partners: {
    heading: "Socios y Patrocinadores",
    futureSmall: "Futuros socios y patrocinadores (marca y co-promoción).",
  },
  registration: {
    heading: "Registro (Vista previa)",
    body:
      "Los flujos de registro se habilitarán cuando se finalicen componentes legales, de cumplimiento y pagos.",
  },
  earlyAccess: {
    title: "Únete a WOW50/50 — Lista de Acceso Anticipado",
    description:
      "Ingresa tu información para recibir actualizaciones mientras se finalizan las estructuras legales, bancarias y de cumplimiento.",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    address: "Dirección",
    ageRange: "Rango de edad",
    orgLine:
      "Somos una organización humanitaria e investigativa — por favor proporciona ciudad/parroquia, estado/provincia, país, región y código postal.",
    cityParish: "Ciudad / Parroquia",
    stateProvince: "Estado / Provincia",
    country: "País",
    region: "Región",
    zip: "Código postal",
    useLabel: "¿Cómo te gustaría usar WOW50/50?",
    usePlaceholder:
      "Por ejemplo: recaudar fondos, construir ahorros, voluntariado, acceso al mercado, etc.",
    permission:
      "Doy permiso a WOW50/50 para compartir mi información para otros beneficios, descuentos, oportunidades e información oportuna (cuando esté disponible).",
    attachmentsTitle: "Adjuntos (opcional)",
    attachmentsDesc: "Sube documentos o imágenes. Guardamos los nombres de archivo + los nombres enviados por correo.",
    consentText: "Confirmo que la información es correcta y acepto ser contactado por WOW50/50.",
    button: "Unirme a acceso anticipado",
    success: "Gracias — estás en la lista de acceso anticipado.",
    error: "Algo salió mal. Inténtalo de nuevo.",
  },

  programTracks: {
    veterans: {
      heading: "Programas de Apoyo a Veteranos y Militares",
      startIntake: "Iniciar formulario",
      blurb:
        "WOW50/50 incluye vías dedicadas para veteranos, miembros activos, trabajadores civiles y familias militares — con empleo, emprendimiento y servicios de reintegración.",
      helpTitle: "Información y servicios de referencia",
      helpBullets: [
        "Oportunidades de bienestar de salud mental y rehabilitación física (incluye opciones holísticas).",
        "Servicios de transición y reintegración (estabilidad de vivienda, conexión comunitaria, apoyo de reingreso).",
        "Lenguaje de preparación SDVOSB / VOSB (posicionamiento listo para certificación y rutas).",
        "Rutas de empleo para veteranos (capacitación → colocación → retención).",
        "Apoyo para seres queridos, familia y mascotas de veteranos/servicio activo.",
        "Navegación de oportunidades de financiamiento (transporte, propiedades, vivienda, negocios e ideas innovadoras).",
        "Apoyo a negocios propiedad de veteranos/servicio activo (lanzamiento, crecimiento, marketing, acceso al marketplace).",
        "Alianzas y vending con VA / empleadores (MOUs o pipelines activos o planificados).",
      ],
      unlocksTitle: "Desbloqueos",
      unlocksBullets: [
        "Oportunidades especiales de DOL VETS: fondos, subvenciones, avales, inversiones ángel y alineación de negocios para veteranos.",
        "Credibilidad VA OSDBU para alcance y eventos.",
        "Interés de primes (SAIC / GDIT y otros grandes empleadores).",
        "Registro de proveedores y compras, mentoría, pasantías e itinerarios de contratación.",
      ],
      notes:
        "Nota: El lenguaje se presenta como diseño de programa y apoyo de preparación (no es asesoría legal / no es certificación).",
      trackLabel: "Apoyo a Veteranos y Militares",
      options: [
        { id: "employment", label: "Capacitación + colocación" },
        { id: "business-support", label: "Apoyo a negocio de veteranos" },
        { id: "transition", label: "Transición / reintegración" },
        { id: "sdvosb-vosb", label: "Preparación SDVOSB / VOSB" },
        { id: "funding", label: "Oportunidades de financiamiento" },
        { id: "family", label: "Familia / seres queridos / mascotas" },
        { id: "partnerships", label: "Alianzas VA / empleadores" },
      ],
      partnersTitle: "Para aliados y organizaciones comunitarias",
      partnersBody1:
        "Este programa está diseñado para resultados medibles: inscripciones, colocaciones y apoyo continuo.",
      partnersBody2:
        "Nuestro flujo de admisión y derivación ayuda a los veteranos a llegar rápidamente al recurso correcto.",
    },
    workforce: {
      heading: "Desarrollo Laboral y Rutas de Carrera",
      startIntake: "Iniciar formulario",
      blurb:
        "¿Necesitas un mejor trabajo, una nueva habilidad o un camino más rápido hacia el empleo? WOW50/50 te ayuda a crear un plan centrado en habilidades y te conecta con capacitación, vinculación con empleadores y próximos pasos reales — sin requerir un título tradicional.",
      helpTitle: "Cómo podemos ayudar",
      helpBullets: [
        "Capacitación en habilidades (digital, administración, TI, operaciones del mercado).",
        "Rutas basadas en habilidades (STARs / progreso por competencias) para calificar más rápido.",
        "Apoyo de colocación laboral + vinculación con empleadores (referencias, introducciones directas).",
        "Apoyo de reingreso y cambios de carrera.",
        "Seguimiento de resultados (inscripciones, finalizaciones, colocaciones) para mantener la responsabilidad del programa.",
      ],
      trackLabel: "Desarrollo Laboral",
      options: [
        { id: "skills-training", label: "Capacitación / mejora de habilidades" },
        { id: "employment", label: "Colocación / vinculación con empleadores" },
        { id: "re-entry", label: "Apoyo de reingreso / segunda oportunidad" },
        { id: "certs", label: "Guía para certificaciones" },
        { id: "partnerships", label: "Aliado empleador / capacitación" },
      ],
      partnersTitle: "Para empleadores y aliados de fuerza laboral",
      partnersBody1:
        "Apoyamos canales de contratación basados en habilidades: admisión, evaluación, derivación a capacitación, apoyo de colocación e informes de resultados.",
      partnersBody2:
        "Asóciate con WOW50/50 para ampliar tu canal de talento y lograr resultados medibles.",
    },
    economicOpportunity: {
      heading: "Oportunidad Económica y Empoderamiento Financiero",
      startIntake: "Iniciar formulario",
      blurb:
        "Construye estabilidad financiera, aprende a acceder a capital de forma responsable y desarrolla riqueza a largo plazo. WOW50/50 apoya presupuestos, herramientas de crédito, planes de ahorro y preparación para pequeños negocios.",
      helpTitle: "Cómo podemos ayudar",
      helpBullets: [
        "Orientación de bienestar financiero (presupuesto, ahorro, estrategia de deudas).",
        "Guía y herramientas para construir crédito (educación + próximos pasos).",
        "Educación de acceso a capital (preparación, documentos, navegación con prestamistas).",
        "Preparación para pequeños negocios (precios, contabilidad básica, presencia digital).",
        "Rutas de construcción de riqueza comunitaria y derivaciones.",
      ],
      trackLabel: "Oportunidad Económica",
      options: [
        { id: "budgeting", label: "Presupuesto / plan de ahorro" },
        { id: "credit", label: "Guía para construir crédito" },
        { id: "access-to-capital", label: "Educación de acceso a capital" },
        { id: "business-support", label: "Preparación para pequeño negocio" },
        { id: "partnerships", label: "Apoyo de aliado / patrocinador" },
      ],
      partnersTitle: "Para aliados financieros y programas comunitarios",
      partnersBody1:
        "Nos enfocamos en progreso medible: educación, pasos de acción y seguimiento — para pasar de la crisis a la estabilidad y el crecimiento.",
      partnersBody2:
        "Asóciate con WOW50/50 para apoyar la construcción de riqueza comunitaria y la preparación empresarial.",
    },
    federalPartners: {
      heading: "Contratación Federal y Alianzas con Primes",
      startIntake: "Iniciar formulario",
      blurb:
        "Aprende los pasos para estar listo como proveedor y competir por oportunidades federales, estatales y locales. WOW50/50 apoya declaraciones de capacidad, conciencia de cumplimiento y preparación para relaciones prime/sub (no certificación).",
      helpTitle: "Cómo podemos ayudar",
      helpBullets: [
        "Conceptos básicos de preparación de proveedor (capability statement, NAICS, diferenciadores).",
        "Apoyo para conexiones prime–sub y alcance de alianzas.",
        "Guía de conciencia SAM.gov / cumplimiento (educación, no certificación).",
        "Preparación de subcontratación (precios, documentación, narrativa de desempeño).",
        "Derivaciones a recursos locales de compras y OSDBU.",
      ],
      trackLabel: "Alianzas Federales",
      options: [
        { id: "vendor-ready", label: "Conceptos básicos de proveedor" },
        { id: "capability", label: "Apoyo de declaración de capacidad" },
        { id: "federal-market-entry", label: "Subcontratación / entrada al mercado" },
        { id: "sam", label: "SAM.gov / conciencia de cumplimiento" },
        { id: "partnerships", label: "Alcance a primes" },
      ],
      partnersTitle: "Para primes, agencias y aliados del ecosistema",
      partnersBody1:
        "Ayudamos a pequeñas empresas a organizarse y prepararse para oportunidades reales con pasos claros y derivación conforme.",
      partnersBody2:
        "Asóciate con WOW50/50 para ampliar canales de subcontratistas y mejorar resultados de preparación.",
    },
    securityCompliance: {
      heading: "Ciberseguridad y Preparación de Cumplimiento",
      startIntake: "Iniciar formulario",
      blurb:
        "Protege tu organización, clientes y datos. WOW50/50 apoya educación práctica de ciberseguridad, fundamentos de riesgo y rutas de preparación de cumplimiento (incluida conciencia CMMC).",
      helpTitle: "Cómo podemos ayudar",
      helpBullets: [
        "Higiene cibernética básica (contraseñas, MFA, prevención de phishing).",
        "Prácticas de protección de datos para equipos pequeños (políticas + herramientas).",
        "Educación de conciencia CMMC / cumplimiento y pasos de preparación (no certificación).",
        "Responsabilidad del proveedor y apoyo de documentación de seguridad.",
        "Derivaciones a aliados confiables para evaluaciones e implementación.",
      ],
      trackLabel: "Seguridad y Cumplimiento",
      options: [
        { id: "cmmc-awareness", label: "Conciencia CMMC / cumplimiento" },
        { id: "data-protection", label: "Protección de datos" },
        { id: "policies", label: "Políticas y documentación" },
        { id: "training", label: "Capacitación / concientización" },
        { id: "partnerships", label: "Derivación a aliado / evaluación" },
      ],
      partnersTitle: "Para aliados de ciberseguridad y programas de cumplimiento",
      partnersBody1:
        "Ayudamos a entender requisitos, tomar pasos prácticos y conectar con proveedores verificados para trabajo avanzado.",
      partnersBody2:
        "Asóciate con WOW50/50 para ampliar educación de preparación y prácticas responsables de proveedores.",
    },
    communityImpact: {
      heading: "Impacto Comunitario y Beneficio Público",
      startIntake: "Iniciar formulario",
      blurb:
        "Apoya a la comunidad mediante voluntariado, ayuda mutua y beneficio público medible. WOW50/50 conecta personas con programas locales, eventos y rutas de servicio.",
      helpTitle: "Cómo podemos ayudar",
      helpBullets: [
        "Oportunidades de voluntariado y pasantías.",
        "Programas comunitarios y derivaciones (acceso a alimentos, estabilidad de vivienda, reingreso).",
        "Coordinación de eventos de recaudación y alcance comunitario.",
        "Apoyo para seguimiento e informes de beneficio público.",
        "Conexiones con organizaciones sin fines de lucro y servicios confiables.",
      ],
      trackLabel: "Impacto Comunitario",
      options: [
        { id: "volunteer-programs", label: "Voluntariado / pasantía" },
        { id: "events", label: "Eventos / alcance" },
        { id: "food-access", label: "Apoyo de acceso a alimentos" },
        { id: "housing", label: "Derivación de vivienda" },
        { id: "partnerships", label: "Colaboración con aliados" },
      ],
      partnersTitle: "Para organizaciones sin fines de lucro y aliados de beneficio público",
      partnersBody1:
        "Nos enfocamos en derivación clara, participación medible y conectar voluntarios con necesidades reales.",
      partnersBody2:
        "Asóciate con WOW50/50 para aumentar participación, mejorar resultados y fortalecer redes locales.",
    },
  },

  intakeInline: {
    title: "Formulario rápido",
    sub:
      "Dinos qué buscas — te conectaremos con el programa correcto y los próximos pasos.",
    fullIntake: "Formulario completo",
    interestedIn: "Me interesa",
    zipOptional: "Código postal (opcional)",
    fullName: "Nombre completo",
    yourName: "Tu nombre",
    email: "Correo electrónico",
    phoneOptional: "Teléfono (opcional)",
    notesOptional: "Notas (opcional)",
    notesPlaceholder: "Cuéntanos tu objetivo y tu tiempo (opcional).",
    submit: "Enviar",
    submitting: "Enviando…",
    success:
      "Gracias — recibimos tu solicitud. Siguiente: usa el botón de abajo para continuar.",
    errorName: "Por favor ingresa tu nombre.",
    errorEmail: "Por favor ingresa tu correo electrónico.",
    footer: "Responderemos con los próximos pasos y los recursos correctos.",
    continue: "Continuar →",
  },

  intakePage: {
    heading: "Formulario de Admisión",
    sub:
      "Dinos qué necesitas y te derivaremos a los programas, recursos y próximos pasos adecuados.",
    back: "Atrás",
    programArea: "Área del programa",
    select: "Seleccionar…",
    iAm: "Soy…",
    roles: {
      individual: "Miembro de la comunidad / individuo",
      business: "Propietario de negocio",
      nonprofit: "ONG / organización comunitaria",
      partner: "Empleador / aliado / agencia",
    },
    fullName: "Nombre completo",
    email: "Correo electrónico",
    phoneOptional: "Teléfono (opcional)",
    zipOptional: "Código postal (opcional)",
    needsTitle: "¿En qué necesitas ayuda?",
    tip: "Consejo: puedes seleccionar varias opciones — te guiaremos al lugar correcto.",
    notesOptional: "Notas (opcional)",
    notesPlaceholder:
      "Describe brevemente tu objetivo, tu tiempo y cualquier limitación.",
    submit: "Enviar admisión",
    submitting: "Enviando…",
    errProgram: "Por favor selecciona un área del programa.",
    errName: "Por favor ingresa tu nombre.",
    errEmail: "Por favor ingresa tu correo electrónico.",
    success:
      "Enviado. Siguiente: usa los botones de abajo para continuar al lugar correcto.",
    nextSteps: "Próximos pasos",
    backToStart: "Volver a donde empezaste",
    goTo: "Ir a {program}",
    contactUs: "Contáctanos",
    volunteer: "Voluntariado",
    review:
      "Revisaremos tu admisión y te daremos seguimiento con la ruta correcta y recursos oficiales.",
    needsOptions: {
      employment: "Empleo / colocación laboral",
      skillsTraining: "Capacitación / mejora de habilidades",
      businessSupport: "Apoyo empresarial / acceso al mercado",
      accessToCapital: "Educación de acceso a capital",
      federalMarketEntry: "Entrada a contratación federal / subcontratación",
      cmmcAwareness: "Ciberseguridad / preparación de cumplimiento",
      volunteerPrograms: "Voluntariado / participación comunitaria",
      partnerships: "Alianzas / canal de empleadores",
    },
  },

  ticket: {
    heading: "Ticket de Soporte",
    sub: "¿Necesitas ayuda? Envía un ticket y te responderemos por email.",
    name: "Nombre (opcional)",
    email: "Correo",
    subject: "Asunto (opcional)",
    message: "Mensaje",
    submit: "Enviar ticket",
    success: "Ticket enviado. Gracias.",
    error: "Falló el envío. Inténtalo de nuevo.",
  },
  footer: {
    tollFree: "Teléfono gratuito global:",
    hashtag: "#wow5050",
    madeBy: "WOW50/50©️®️™️ is a 2025-6, LRHC&EDC & Global Economic CDC/ A GlobalSOSNOW, Website Program. In partnership exclusively with Toussaint Digital Development within the USA.",
    copyright: "© {year} WOW50/50. Todos los derechos reservados.",
  },
};

export const FR = {
  nav: {
    concept: "Concept",
    tracks: "Parcours",
    veterans: "Vétérans",
    workforce: "Parcours pro",
    economicOpportunity: "Opportunité économique",
    federalPartners: "Opportunités Prime",
    securityCompliance: "Sécurité & conformité",
    communityImpact: "Impact communautaire",
    plans: "Plans",
    marketplace: "Marché",
    donations: "Dons",
    contribution: "Contribution",
    fundraising: "Collecte",
    payments: "Paiements",
    calculator: "Calculatrice",
    events: "Événements",
    outreach: "Actions",
    volunteer: "Bénévolat / Stage",
    finalArrangements: "Dernières volontés",
    legalListings: "Annonces légales",
    partners: "Partenaires",
    registration: "Inscription",
    earlyAccess: "Accès anticipé",
    dashboard: "Tableau de bord",
    login: "Se connecter",
    logout: "Se déconnecter",
  },
  hero: {
    tagline:
      "Collecte d'événements · Bien-être financier · Aide mondiale · Bénévolat / Stage · Dons",
    titleLine2: "Richesse · Opportunité · Bien‑être · Honneur",
    lead:
      "Un programme de collecte 50/50 et de bien‑être économique qui soutient les personnes dans le besoin tout en aidant les participants à constituer une épargne, une protection et une richesse future.",
    joinCta: "Rejoindre l'opportunité",
    learnCta: "Comment fonctionne WOW50/50",
  },
  concept: {
    heading: "WOW50/50 — Aperçu du concept",
    body:
      "WOW50/50 est un programme structuré de collecte 50/50 et de bien‑être financier. 50% soutiennent les personnes dans le besoin et des causes humanitaires vérifiées. 50% soutiennent des parcours d’épargne/bien‑être, les opérations de la plateforme et la croissance future.",
  },
  membership: {
    heading: "Adhésion et cadre de contribution",
    intro:
      "L’adhésion peut commencer à 5$. À 50$, vous devenez membre régulier. Si votre première adhésion est inférieure à 50$, la confirmation est émise lorsque le total atteint 50$.",
    tiersHeading: "Types d’adhésion et niveaux indicatifs",
    tiers: [
      { name: "Jeunes", subtitle: "0–17 ans", amount: "5$", tag: "Entrée / Jeunes" },
      {
        name: "Seniors / ADA / Vétérans",
        subtitle: "62+ · Faible revenu · Non-officier",
        amount: "10$",
        tag: "Niveau soutien",
      },
      {
        name: "Étudiants (Lycée / Tech / Université)",
        subtitle: "",
        amount: "20$*",
        tag: "Niveau étudiant",
      },
      {
        name: "Adultes",
        subtitle: "Seuil de confirmation",
        amount: "50$",
        tag: "Membre régulier (confirmé à 50$)",
      },
      { name: "Entreprise", subtitle: "", amount: "75$*", tag: "Petite entreprise" },
      {
        name: "Professionnel",
        subtitle: "(individuel)",
        amount: "275$*",
        tag: "Services professionnels",
      },
      {
        name: "Corporate",
        subtitle: "Admin 75$ / Équipe 50$",
        amount: "500$",
        tag: "Collaboration corporate",
      },
      {
        name: "Lieux (petits)",
        subtitle: "",
        amount: "250$",
        tag: "Partenariat petit lieu",
      },
      {
        name: "Lieux (grands)",
        subtitle: "",
        amount: "500$",
        tag: "Partenariat grand lieu",
      },
      {
        name: "Cliniques / Médical / Avocat / Fiscalité / Concessions",
        subtitle: "",
        amount: "1 500$",
        tag: "Grandes structures",
      },
      {
        name: "Médias",
        subtitle: "Gratuit avec partenariat co-op d’1 an*",
        amount: "100$",
        tag: "Annonce média (minimum mensuel)",
      },
      {
        name: "PSA / Partenariat co-op d’impact",
        subtitle:
          "Alertes d’urgence, services humanitaires, actions annuelles, cours de certification gratuits, événements écologiques, défense animale & sauvetage",
        amount: "Partenariat",
        tag: "Partenariat co-op d’impact",
      },
    ],
    disclosureTitle: "Information sur la confirmation d’adhésion",
    disclosureBody:
      "L’adhésion peut commencer à 5$. La confirmation complète est émise lorsque le total des contributions atteint 50$ (si le premier paiement est inférieur à 50$).",
    packagesHeading: "Forfaits & avantages",
    packages: [
      {
        title: "Fan Club",
        price: "100$ / mois (en plus de l’adhésion)",
        bullets: [
          "Certificat d’adhésion",
          "T-shirt WOW50/50 (sélection marketplace)",
          "Carte Visa (bientôt)",
        ],
      },
      {
        title: "VIP",
        price: "275$ / mois",
        bullets: [
          "Réductions partenaires",
          "Sélection de guayabera",
          "Offres spéciales marketplace",
          "Visa Platinum (bientôt)",
        ],
        note:
          "VIP et plus : choisissez type/taille/couleur de guayabera. Pour femmes : chemise ou robe (robe +30$).",
      },
      {
        title: "Ambassadeur",
        price: "500$ tous les 3 mois",
        bullets: [
          "Tout le VIP",
          "Pin/stylo/sac avec logo",
          "Commission : 20% par adhésion confirmée",
          "Mise en avant marketplace (aperçu)",
        ],
        highlight: "Payez votre adhésion en aidant à augmenter les adhésions.",
      },
      {
        title: "Ambassadeur Global",
        price: "1 500$ tous les 3 mois",
        bullets: [
          "Tout Ambassadeur",
          "Commission : 25% par adhésion confirmée",
          "Placement carte de visite gratuit (aperçu)",
        ],
        note:
          "Bonus : 2e moitié de l’année gratuite avec le recrutement d’au moins 10 membres mensuels à 1 500$ la première année. Si 20+ sur une année complète : adhésion offerte l’année suivante.",
        finePrint:
          "Adhésion à vie GRATUITE après inscription d’au moins 100 membres ; en règle pendant 5 ans → exonération automatique à vie.",
      },
      {
        title: "Universal Empire (Mini Franchise WOW50/50)",
        price: "1 500$ / mois",
        bullets: [
          "Mini franchise (bientôt)",
          "Premier trimestre : 30% par membre confirmé",
          "Bonus après 20 inscriptions/mois",
        ],
        note:
          "Bonus : 2e moitié de l’année gratuite avec le recrutement d’au moins 5 membres mensuels à 1 500$ la première année. Si 10+ sur une année complète : adhésion offerte l’année suivante.",
        finePrint:
          "Adhésion à vie GRATUITE après inscription d’au moins 50 membres ; en règle pendant 5 ans → exonération automatique à vie.",
      },
    ],
    taxFinePrint:
      "Ambassadeur Global B : aperçu du concept de formulaire fiscal de fin d’année = 1099 (info).",
    taxHeading: "Formulaires fiscaux de fin d’année (Info)",
    taxBody:
      "Des reçus et formulaires d’information peuvent être fournis si applicable (selon la structure finale et l’éligibilité du donateur).",
  },
  marketplace: {
    heading: "Marché & offres membres",
    body:
      "Le Marché WOW50/50 permet aux participants approuvés, partenaires et petites entreprises de publier des produits, services et offres à impact. Les dons peuvent être marqués d’un cadre rouge.",
    externalCta: "Ouvrir le marché",
    vendorCta: "Devenir vendeur",
    memberDiscounts:
      "Les membres peuvent bénéficier de 10% à 20% de réductions selon le commerçant, la zone et la saison.",
    taxReceipt:
      "Les dons peuvent donner droit à un reçu fiscal (si applicable).",
  },
  donationSection: {
    heading: "Dons",
    sub:
      "Exemples d’articles donnés à WOW50/50. Touchez une carte pour publier les détails (description + prix + photos) et éventuellement lister sur le marché — ou continuer l’admission.",
    cardCta: "Touchez pour publier les détails (ou continuer l’admission)",
    items: {
      cars: "Cars",
      clothes: "Clothes",
      motorcycles: "Two-Wheelers",
      twoWheelers: "Two-Wheelers",
      boats: "Boats",
      houses: "Houses",
      lands: "Lands",
      rvs: "RVs",
      plants: "Plants",
      jewelry: "Jewelry",
      constructionEquipment: "Construction Equipment",
      kitchenAppliances: "Kitchen Appliances",
      commercialProperties: "Commercial Properties",
      officeEquipment: "Office Equipment",
      airlineMileageCredit: "Airline Mileage Credit",
      foodAndBeverages: "Food & Beverages",
    },
    dedicationLabel: "Dédicace / note commémorative (optionnel)",
    itemType: "Type de don",
    directLabel: "Cet article est donné directement à WOW50/50",
    directHelp: "Les dons directs peuvent être marqués d’un cadre rouge.",
    tabItems: "Dons en nature",
    tabMedia: "Actualités / Médias",
    tabServices: "Services en nature",
    tabMemorial: "Mémorial / Héritage",
  },
  donationIntake: {
    heading: "Admission de don",
    sub:
      "Confirmez le type de don et la dédicace. Nous vous enverrons un reçu et les instructions par email.",
    submit: "Envoyer l’admission",
  },
  contributionSection: {
    heading: "Contribution",
    sub:
      "Contributions au fonds (financières). Choisissez la fréquence, le montant et une dédicace optionnelle.",
    frequency: "Fréquence",
    amount: "Montant",
    dedication: "Dédicace / note commémorative (optionnel)",
    submit: "Envoyer la contribution",
  },
  fundraising: { heading: "Collecte & aide mondiale" },
  payments: {
    heading: "Traitement des paiements et contributions",
    body:
      "WOW50/50 intégrera des processeurs de paiement conformes pour accepter les cartes ou paiements bancaires.",
    button: "Paiements bientôt disponibles",
  },
  calculator: {
    heading: "Calculatrice — contribution & moteur de richesse",
    body:
      "Exemple visuel de la manière dont une contribution mensuelle peut être structurée dans le modèle WOW Wealth Engine.",
  },
  events: { heading: "Événements · Campagnes · Activations", body: "Publiez des événements et campagnes. Enregistrés sur cet appareil et peuvent notifier l’équipe WOW." },
  outreach: {
    heading: "Actions communautaires & écologiques",
    body:
      "Nous organisons des actions communautaires et écologiques. Nous fournissons des heures de service communautaire et des lettres de valeur de contribution.",
  },
  volunteer: {
    heading: "Bénévolat / Stage",
    body:
      "Participez aux actions, campagnes de collecte, opérations du marché et initiatives de soutien communautaire.",
  },
  finalArrangements: {
    heading: "Dernières volontés & mémoriaux",
    sub:
      "Navigation à tarif réduit pour crémation, enterrement et expédition internationale. Option de page mémorial incluse.",
    memorialTitle: "Page mémorial (1 mois)",
    memorialBody:
      "Ajoutez un message mémorial et une photo (galerie). Exemple : 50$/mois pour l’affichage.",
  },
  legalListings: {
    heading: "Annonces légales & avis publics",
    sub:
      "Cliquez sur une catégorie pour publier (titre, description, contact, prix/fichiers optionnels).",
    items: [
      "Public",
      "Commercial",
      "Ordonnance",
      "Nom fictif",
      "Annonce",
      "Annonce légale",
      "Soutien juridique",
      "Tourisme / Voyages",
      "Rural / Agriculture",
      "Biens excédentaires",
      "Brocantes / Enchères",
      "Médias / Production / Sécurité",
      "Recyclage",
      "Produits minoritaires",
      "Cours de langues",
      "Services pour animaux",
    ],
    publishHint:
      "Publier : titre · description · contact · prix/fichiers optionnels",
    directoryTitle: "Répertoire de données US",
    directorySub:
      "Connectez des sources fédérales + étatiques + de comté. Beaucoup de juridictions n’ont pas d’API unique ; nous relions les portails officiels et ajoutons des connecteurs au fil du temps.",
    selectState: "État",
    selectCounty: "Comté",
    allCounties: "Tous les comtés",
    loadingCounties: "Chargement des comtés…",
    sourcesTitle: "Connecteurs que vous pouvez intégrer",
    coverage: {
      federal: "Fédéral",
      state: "État",
      county: "Comté",
      multi: "Multi‑états",
      paid: "Payant / accès requis",
    },
    localDevTip:
      "Astuce : en local, lancez `vercel dev` pour que /api fonctionne (liste des comtés et connecteurs).",
  },
  partners: {
    heading: "Partenaires & sponsors",
    futureSmall: "Futurs partenaires & sponsors (branding et co‑promotion).",
  },
  registration: {
    heading: "Inscription (aperçu)",
    body:
      "Les parcours d’inscription seront activés lorsque les composants juridiques, conformité et paiement seront finalisés.",
  },
  earlyAccess: {
    title: "Rejoindre WOW50/50 — liste d’accès anticipé",
    description:
      "Renseignez vos informations pour recevoir des mises à jour pendant la finalisation des structures légales, bancaires et de conformité.",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    address: "Adresse",
    ageRange: "Tranche d’âge",
    orgLine:
      "Nous sommes une organisation humanitaire et de recherche — veuillez fournir ville/parroisse, état/province, pays, région et code postal.",
    cityParish: "Ville / Parroisse",
    stateProvince: "État / Province",
    country: "Pays",
    region: "Région",
    zip: "Code postal",
    useLabel: "Comment souhaitez‑vous utiliser WOW50/50 ?",
    usePlaceholder:
      "Ex : collecter des fonds, épargne personnelle, bénévolat, accès au marché, etc.",
    permission:
      "J’autorise WOW50/50 à partager mes informations pour d’autres avantages, remises, opportunités et informations prioritaires (si disponibles).",
    attachmentsTitle: "Pièces jointes (optionnel)",
    attachmentsDesc: "Téléchargez des documents ou des images. Nous enregistrons les noms de fichiers + les noms envoyés par e-mail.",
    consentText: "Je confirme que les informations sont exactes et j’accepte d’être contacté par WOW50/50.",
    button: "Rejoindre l’accès anticipé",
    success: "Merci — vous êtes sur la liste d’accès anticipé.",
    error: "Une erreur s’est produite. Réessayez.",
  },

  programTracks: {
    veterans: {
      heading: "Programmes de soutien aux vétérans et aux militaires",
      startIntake: "Commencer l’admission",
      blurb:
        "WOW50/50 propose des parcours dédiés pour les vétérans, militaires en service, travailleurs civils et familles — emploi, entrepreneuriat et services de réintégration.",
      helpTitle: "Information & services d’orientation",
      helpBullets: [
        "Opportunités de bien‑être (santé mentale + réhabilitation physique), y compris des options holistiques.",
        "Services de transition & réintégration (stabilité logement, lien communautaire, soutien à la réinsertion).",
        "Préparation SDVOSB / VOSB (positionnement et parcours “prêts certification”).",
        "Parcours emploi vétérans (formation → placement → rétention).",
        "Soutien pour proches, familles et animaux (vétérans / service actif).",
        "Navigation des opportunités de financement (transport, propriétés, logement, entreprise, concepts innovants).",
        "Soutien aux entreprises détenues par vétérans/AD (lancement, croissance, marketing, accès marketplace).",
        "Partenariats & vending avec la VA / employeurs (MOUs/pipelines actifs ou planifiés).",
      ],
      unlocksTitle: "Déblocages",
      unlocksBullets: [
        "Opportunités DOL VETS : financements, subventions, recommandations, investissements “angel”, alignement business vétérans.",
        "Crédibilité VA OSDBU pour l’outreach et les événements.",
        "Intérêt des grands donneurs d’ordres (SAIC / GDIT et autres grands employeurs).",
        "Inscription fournisseurs/achats, mentorat, stages et parcours de contractualisation.",
      ],
      notes:
        "Note : langage présenté comme conception de programme et soutien à la préparation (pas un avis juridique / pas une certification).",
      trackLabel: "Soutien vétérans & militaires",
      options: [
        { id: "employment", label: "Formation + placement" },
        { id: "business-support", label: "Soutien entreprise vétéran" },
        { id: "transition", label: "Transition / réintégration" },
        { id: "sdvosb-vosb", label: "Préparation SDVOSB / VOSB" },
        { id: "funding", label: "Opportunités de financement" },
        { id: "family", label: "Famille / proches / animaux" },
        { id: "partnerships", label: "Partenariats VA / employeurs" },
      ],
      partnersTitle: "Pour les partenaires et organisations communautaires",
      partnersBody1:
        "Ce programme vise des résultats mesurables : inscriptions, placements et soutien continu.",
      partnersBody2:
        "Notre flux d’admission et d’orientation aide les vétérans à atteindre rapidement la bonne ressource.",
    },
    workforce: {
      heading: "Développement de la main‑d’œuvre et parcours de carrière",
      startIntake: "Commencer l’admission",
      blurb:
        "Besoin d’un meilleur emploi, d’une nouvelle compétence ou d’un accès plus rapide au travail ? WOW50/50 vous aide à construire un plan centré sur les compétences et vous connecte à la formation, au matching employeurs et à de vraies prochaines étapes — sans diplôme traditionnel obligatoire.",
      helpTitle: "Comment nous pouvons aider",
      helpBullets: [
        "Formations (numérique, administratif, IT, opérations marketplace).",
        "Parcours axés sur les compétences (STARs / progression par compétences) pour avancer plus vite.",
        "Soutien au placement + matching employeurs (références, mises en relation).",
        "Soutien pour réinsertion et changements de carrière.",
        "Suivi des résultats (inscriptions, réussites, placements) pour renforcer la responsabilité.",
      ],
      trackLabel: "Développement de la main‑d’œuvre",
      options: [
        { id: "skills-training", label: "Formation / montée en compétences" },
        { id: "employment", label: "Placement / matching employeurs" },
        { id: "re-entry", label: "Réinsertion / seconde chance" },
        { id: "certs", label: "Conseils certifications" },
        { id: "partnerships", label: "Partenaire employeur / formation" },
      ],
      partnersTitle: "Pour les employeurs et partenaires main‑d’œuvre",
      partnersBody1:
        "Nous soutenons des pipelines d’embauche basés sur les compétences : admission, tri, orientation formation, placement et reporting.",
      partnersBody2:
        "Partenariat avec WOW50/50 pour élargir votre vivier de talents et produire des résultats mesurables.",
    },
    economicOpportunity: {
      heading: "Opportunité économique et autonomisation financière",
      startIntake: "Commencer l’admission",
      blurb:
        "Renforcez votre stabilité financière, apprenez à accéder au capital de manière responsable et développez votre richesse à long terme. WOW50/50 soutient le budget, les outils de crédit, les plans d’épargne et la préparation des petites entreprises.",
      helpTitle: "Comment nous pouvons aider",
      helpBullets: [
        "Coaching de bien‑être financier (budget, épargne, stratégie dettes).",
        "Conseils et outils de construction de crédit (éducation + prochaines étapes).",
        "Éducation à l’accès au capital (préparation, documents, navigation prêteurs).",
        "Préparation petite entreprise (prix, bases comptables, présence digitale).",
        "Parcours de création de richesse communautaire et orientations.",
      ],
      trackLabel: "Opportunité économique",
      options: [
        { id: "budgeting", label: "Budget / plan d’épargne" },
        { id: "credit", label: "Construction de crédit" },
        { id: "access-to-capital", label: "Accès au capital (éducation)" },
        { id: "business-support", label: "Préparation petite entreprise" },
        { id: "partnerships", label: "Soutien partenaire / sponsor" },
      ],
      partnersTitle: "Pour les partenaires financiers et programmes communautaires",
      partnersBody1:
        "Nous visons des progrès mesurables : éducation, actions et suivi — pour passer de la crise à la stabilité puis à la croissance.",
      partnersBody2:
        "Partenariat avec WOW50/50 pour soutenir la création de richesse communautaire et la préparation des entrepreneurs.",
    },
    federalPartners: {
      heading: "Marchés fédéraux et partenariats avec les primes",
      startIntake: "Commencer l’admission",
      blurb:
        "Apprenez les étapes pour être prêt en tant que fournisseur et candidater à des opportunités fédérales, étatiques et locales. WOW50/50 soutient les capability statements, la sensibilisation conformité et la préparation aux relations prime/sub (pas une certification).",
      helpTitle: "Comment nous pouvons aider",
      helpBullets: [
        "Bases de préparation fournisseur (capability statement, NAICS, différenciation).",
        "Soutien aux connexions prime–sub et au développement de partenariats.",
        "Sensibilisation SAM.gov / conformité (éducation, pas certification).",
        "Préparation sous‑traitance (prix, documents, récit de performance).",
        "Orientations vers les ressources procurement et OSDBU locales.",
      ],
      trackLabel: "Opportunités Prime",
      options: [
        { id: "vendor-ready", label: "Bases fournisseur" },
        { id: "capability", label: "Soutien capability statement" },
        { id: "federal-market-entry", label: "Sous‑traitance / entrée marché" },
        { id: "sam", label: "SAM.gov / sensibilisation conformité" },
        { id: "partnerships", label: "Approche primes" },
      ],
      partnersTitle: "Pour les primes, agences et partenaires d’écosystème",
      partnersBody1:
        "Nous aidons les petites entreprises à s’organiser et à se préparer avec des étapes claires et une orientation conforme.",
      partnersBody2:
        "Partenariat avec WOW50/50 pour élargir les pipelines de sous‑traitants et améliorer la préparation.",
    },
    securityCompliance: {
      heading: "Cybersécurité et préparation conformité",
      startIntake: "Commencer l’admission",
      blurb:
        "Protégez votre organisation, vos clients et vos données. WOW50/50 soutient une éducation cybersécurité pratique, les bases du risque et des parcours de préparation conformité (dont sensibilisation CMMC).",
      helpTitle: "Comment nous pouvons aider",
      helpBullets: [
        "Hygiène cyber de base (mots de passe, MFA, anti‑phishing).",
        "Protection des données pour petites équipes (politiques + outils).",
        "Sensibilisation CMMC / conformité et étapes de préparation (pas certification).",
        "Responsabilité fournisseur et documentation sécurité.",
        "Orientations vers des partenaires fiables pour audits et mise en œuvre.",
      ],
      trackLabel: "Sécurité & conformité",
      options: [
        { id: "cmmc-awareness", label: "Sensibilisation CMMC / conformité" },
        { id: "data-protection", label: "Protection des données" },
        { id: "policies", label: "Politiques & documentation" },
        { id: "training", label: "Formation / sensibilisation" },
        { id: "partnerships", label: "Orientation partenaire / audit" },
      ],
      partnersTitle: "Pour les partenaires cybersécurité et programmes conformité",
      partnersBody1:
        "Nous aidons à comprendre les exigences, à agir concrètement et à se connecter à des prestataires vérifiés pour aller plus loin.",
      partnersBody2:
        "Partenariat avec WOW50/50 pour étendre l’éducation à la préparation et les bonnes pratiques fournisseurs.",
    },
    communityImpact: {
      heading: "Impact communautaire et bénéfice public",
      startIntake: "Commencer l’admission",
      blurb:
        "Soutenez les communautés par le bénévolat, l’entraide et un bénéfice public mesurable. WOW50/50 connecte les personnes aux programmes locaux, événements et parcours de service.",
      helpTitle: "Comment nous pouvons aider",
      helpBullets: [
        "Opportunités de bénévolat et de stage.",
        "Programmes communautaires et orientations (accès alimentaire, stabilité logement, réinsertion).",
        "Coordination d’événements de collecte et d’actions terrain.",
        "Soutien au suivi et reporting du bénéfice public.",
        "Connexions à des associations locales et services fiables.",
      ],
      trackLabel: "Impact communautaire",
      options: [
        { id: "volunteer-programs", label: "Bénévolat / stage" },
        { id: "events", label: "Événements / outreach" },
        { id: "food-access", label: "Accès alimentaire" },
        { id: "housing", label: "Orientation logement" },
        { id: "partnerships", label: "Collaboration partenaires" },
      ],
      partnersTitle: "Pour les associations et partenaires d’intérêt général",
      partnersBody1:
        "Nous privilégions une orientation claire, un engagement mesurable et la connexion des bénévoles aux besoins réels.",
      partnersBody2:
        "Partenariat avec WOW50/50 pour augmenter la participation, améliorer les résultats et renforcer les réseaux locaux.",
    },
  },

  intakeInline: {
    title: "Admission rapide",
    sub:
      "Dites‑nous ce que vous recherchez — nous vous orienterons vers le bon programme et les prochaines étapes.",
    fullIntake: "Admission complète",
    interestedIn: "Je suis intéressé(e) par",
    zipOptional: "Code postal (optionnel)",
    fullName: "Nom complet",
    yourName: "Votre nom",
    email: "Email",
    phoneOptional: "Téléphone (optionnel)",
    notesOptional: "Notes (optionnel)",
    notesPlaceholder: "Indiquez votre objectif et votre délai (optionnel).",
    submit: "Envoyer",
    submitting: "Envoi…",
    success:
      "Merci — nous avons bien reçu votre demande. Ensuite : utilisez le bouton ci‑dessous pour continuer.",
    errorName: "Veuillez saisir votre nom.",
    errorEmail: "Veuillez saisir votre email.",
    footer: "Nous répondrons avec les prochaines étapes et les bonnes ressources.",
    continue: "Continuer →",
  },

  intakePage: {
    heading: "Formulaire d’admission",
    sub:
      "Dites‑nous ce dont vous avez besoin et nous vous orienterons vers les bons programmes, ressources et prochaines étapes.",
    back: "Retour",
    programArea: "Domaine du programme",
    select: "Sélectionner…",
    iAm: "Je suis…",
    roles: {
      individual: "Membre de la communauté / individu",
      business: "Chef d’entreprise",
      nonprofit: "Association / organisation communautaire",
      partner: "Employeur / partenaire / agence",
    },
    fullName: "Nom complet",
    email: "Email",
    phoneOptional: "Téléphone (optionnel)",
    zipOptional: "Code postal (optionnel)",
    needsTitle: "De quoi avez‑vous besoin ?",
    tip:
      "Astuce : vous pouvez en sélectionner plusieurs — nous vous orienterons au bon endroit.",
    notesOptional: "Notes (optionnel)",
    notesPlaceholder:
      "Décrivez brièvement votre objectif, votre délai et vos contraintes.",
    submit: "Envoyer l’admission",
    submitting: "Envoi…",
    errProgram: "Veuillez sélectionner un domaine du programme.",
    errName: "Veuillez saisir votre nom.",
    errEmail: "Veuillez saisir votre email.",
    success:
      "Envoyé. Ensuite : utilisez les boutons ci‑dessous pour continuer au bon endroit.",
    nextSteps: "Prochaines étapes",
    backToStart: "Retour à votre point de départ",
    goTo: "Aller à {program}",
    contactUs: "Nous contacter",
    volunteer: "Bénévolat",
    review:
      "Nous examinerons votre admission et ferons un suivi avec le bon parcours et les ressources officielles.",
    needsOptions: {
      employment: "Emploi / placement",
      skillsTraining: "Formation / montée en compétences",
      businessSupport: "Soutien entreprise / accès marketplace",
      accessToCapital: "Accès au capital (éducation)",
      federalMarketEntry: "Entrée marchés fédéraux / sous‑traitance",
      cmmcAwareness: "Cybersécurité / préparation conformité",
      volunteerPrograms: "Bénévolat / engagement communautaire",
      partnerships: "Partenariats / pipeline employeurs",
    },
  },

  ticket: {
    heading: "Ticket support",
    sub: "Besoin d’aide ? Envoyez un ticket et nous vous répondrons par email.",
    name: "Nom (optionnel)",
    email: "Email",
    subject: "Objet (optionnel)",
    message: "Message",
    submit: "Envoyer le ticket",
    success: "Ticket envoyé. Merci.",
    error: "Échec de l’envoi. Réessayez.",
  },
  footer: {
    tollFree: "Numéro gratuit mondial :",
    hashtag: "#wow5050",
    madeBy: "WOW50/50©️®️™️ is a 2025-6, LRHC&EDC & Global Economic CDC/ A GlobalSOSNOW, Website Program. In partnership exclusively with Toussaint Digital Development within the USA.",
    copyright: "© {year} WOW50/50. Tous droits réservés.",
  },
};



export const translations = { en: EN, es: ES, fr: FR };
